<template>
  <div class="home">
    <headers></headers>

    <div class="banner">
      <div class="all_box">
        <div class="banner_body">
          <h3>同城急送&nbsp&nbsp&nbsp&nbsp找睿兔跑腿</h3>
          <h4>
            <span>3</span
            >秒响应&nbsp&nbsp&nbsp<span>5</span>分钟上门&nbsp&nbsp&nbsp平均<span>38</span>分钟搞定
          </h4>
          <div class="banner_btn_box">
            <div class="banner_btn_one" @click="toXd">立即下单</div>
            <xccCode ref="xccCode" v-if="xccCodeVisible"></xccCode>
            <div class="banner_btn_two" @click="openCode">手机下单</div>
          </div>
        </div>
      </div>
      <img src="../assets/banner.png" style="width: 100%" alt="" />
    </div>

    <div class="bodyOne">
      <div class="bodyOne_top">
        <div class="title">
          <h3>睿兔跑腿 为您提供高效便捷的同城及时生活服务</h3>
          <p>3秒响应 5分钟上门 平均38分钟搞定</p>
        </div>
      </div>
      <div class="bodyOne_bottom">
        <div class="all_box">
          <div class="bodyOne_body">
            <div class="bodyOne_item">
              <div class="item_pic">
                <img src="../assets/index_one01.png" alt="" />
              </div>
              <div class="item_text">
                <h3>文件资料重要物品</h3>
                <h3>安心托付急速送全城</h3>
                <div class="item_text_p">
                  <p>手机数码 实时追踪安全保障</p>
                  <p>紧急文件全城安心急速护送</p>
                  <p>商品配送 定制方案高效省心</p>
                </div>
              </div>
            </div>
            <div class="bodyOne_item">
              <div class="item_pic">
                <img src="../assets/index_one02.png" alt="" />
              </div>
              <div class="item_text">
                <h3>美食生鲜百货</h3>
                <h3>足不出户轻松购全城</h3>
                <div class="item_text_p">
                  <p>生鲜百货 一键下单购遍全城</p>
                  <p>美味时刻 吃遍全城缤纷美食</p>
                  <p>紧急药品 7*24小时绿色通道</p>
                </div>
              </div>
            </div>
            <div class="bodyOne_item">
              <div class="item_pic">
                <img src="../assets/index_one03.png" alt="" />
              </div>
              <div class="item_text">
                <h3>同城急事全能帮手</h3>
                <h3>一键托付从容搞定</h3>
                <div class="item_text_p">
                  <p>宠物照看 专人投喂全心守护</p>
                  <p>睿兔家政 省事省心价格透明</p>
                  <p>全能帮手 轻松帮您搞定琐事</p>
                </div>
              </div>
            </div>
            <div class="bodyOne_item">
              <div class="item_pic">
                <img src="../assets/index_one04.png" alt="" />
              </div>
              <div class="item_text">
                <h3>宝贵时间不浪费</h3>
                <h3>睿兔帮排队轻松应对</h3>
                <div class="item_text_p">
                  <p>证件办理 拒绝无聊漫长等待</p>
                  <p>餐厅排队 开启VVIP随享美味</p>
                  <p>办事排队尽享省心高效生活</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <img src="../assets/index_one_bg.png" style="width: 100%" alt="" />
      </div>
    </div>

    <div class="body_three">
      <div class="all_box">
        <div class="title">
          <h3>专业可靠的合作伙伴</h3>
          <p>匠心 让我们精益求精</p>
        </div>
        <div class="three_body">
          <div class="three_item">
            <div class="three_item_box">
              <img src="../assets/friend/friend01.png" alt="" />
            </div>
          </div>
          <div class="three_item">
            <div class="three_item_box">
              <img src="../assets/friend/friend02.png" alt="" />
            </div>
          </div>
          <div class="three_item">
            <div class="three_item_box">
              <img src="../assets/friend/friend03.png" alt="" />
            </div>
          </div>
          <div class="three_item">
            <div class="three_item_box">
              <img src="../assets/friend/friend04.png" alt="" />
            </div>
          </div>
          <div class="three_item">
            <div class="three_item_box">
              <img src="../assets/friend/friend05.png" alt="" />
            </div>
          </div>
          <div class="three_item">
            <div class="three_item_box">
              <img src="../assets/friend/friend06.png" alt="" />
            </div>
          </div>
          <div class="three_item">
            <div class="three_item_box">
              <img src="../assets/friend/friend07.png" alt="" />
            </div>
          </div>
          <div class="three_item">
            <div class="three_item_box">
              <img src="../assets/friend/friend08.png" alt="" />
            </div>
          </div>
          <div class="three_item">
            <div class="three_item_box">
              <img src="../assets/friend/friend09.png" alt="" />
            </div>
          </div>
          <div class="three_item">
            <div class="three_item_box">
              <img src="../assets/friend/friend10.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <joinComponents h3="睿兔跑腿 全国城市合伙人计划" p="携手睿兔顶尖智能集团 开创分享经济奇迹"></joinComponents>

    <buildingSystem></buildingSystem>


    <foot></foot>
  </div>
</template>

<script>
import xccCode from "@/components/xccCode.vue"
import headers from "@/components/header.vue"
import foot from "@/components/foot.vue"
import joinComponents from "@/components/joinComponents.vue"
import buildingSystem from "@/components/buildingSystem"
export default {
  name: "HomeView",
  data() {
    return {
      xccCodeVisible:false
    }
  },

  components: {
    headers,
    foot,
    buildingSystem,
    joinComponents,
    xccCode
  },



  methods: {
    openCode(){
      this.xccCodeVisible = true
      this.$nextTick(()=>{
        this.$refs.xccCode.init()
      })
    },
    toXd(){
      this.$router.push({name:'placeOrder'})
    }
  }
};
</script>
<style lang="scss" scoped>
img {
  display: block;
}
.all_box {
  width: 1380px;
  margin: 0 auto;
  position: relative;
}

.banner {
  .banner_body {
    position: absolute;
    text-align: left;
    padding-top: 140px;
    h3 {
      font-size: 75px;
      color: #fff;
      font-weight: bold;
      margin: 0;
      margin-bottom: 35px;
    }
    h4 {
      font-size: 40px;
      color: #ffffff;
      margin: 0;
      font-weight: 400;
      span {
        font-size: 55px;
        font-weight: bold;
      }
    }
    .banner_btn_box {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      margin-top: 40px;
      .banner_btn_one{
        cursor: pointer;
        width: 187px;
        height: 63px;
        line-height: 63px;
        background: #fff;
        color: #3162b2;
        text-align: center;
        border-radius: 10px;
        border: 2px solid #fff;
      }
      .banner_btn_two{
        cursor: pointer;
        width: 187px;
        height: 63px;
        line-height: 63px;
        background: #1561cb;
        color: #fff;
        border-radius: 10px;
        text-align: center;
        border: 2px solid #4378c5;
        margin-left: 40px;
      }
    }
  }
}

.body_three {
  padding-top: 70px;
  .title {
    padding-bottom: 70px;
    h3 {
      font-size: 32px;
      color: #333333;
      font-weight: bold;
      margin: 0;
      margin-bottom: 25px;
    }
    p {
      font-size: 20px;
      margin: 0;
      color: #969696;
    }
  }
  .three_body {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    .three_item {
      width: 20%;
      margin-bottom: 20px;
      height: 155px;
      .three_item_box {
        width: 90%;
        height: 100%;
        margin: 0 auto;
        border: 1px solid #e3e3e3;
        img{
          height: 100%;
          margin: 0 auto;
        }
      }
    }
  }
}


.banner {
  background: red;
}



.bodyOne {
  padding-top: 80px;
  .bodyOne_top {
    padding-bottom: 270px;
    .title {
      h3 {
        font-size: 32px;
        font-weight: bold;
        color: #333333;
        margin: 0;
        margin-bottom: 20px;
      }
      p {
        font-size: 20px;
        color: #969696;
        margin: 0;
      }
    }
  }
  .bodyOne_bottom {
    .bodyOne_body {
      position: absolute;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      top: -160px;
      .bodyOne_item {
        background: #fff;
        border-radius: 15px;
        overflow: hidden;
        width: 24%;
        .item_pic {
          img {
            width: 100%;
          }
        }
        .item_text {
          background: #fff;
          padding: 35px 30px;
          box-sizing: border-box;
          text-align: left;
          h3 {
            margin: 0;
            font-size: 18px;
            color: #333333;
          }
          .item_text_p {
            p {
              margin: 0;
              margin: 30px 0;
              font-size: 14px;
              color: #969696;
            }

            p:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
    }
  }
}
.xcxImg{
  position: fixed;
  width: 100%;
  height: 100vh;
  background: rgba(0,0,0,.6);
}

</style>